let prescriptionData = [
  {
    title: 'Anxiety',
    description:
      'Anxiety is a health condition characterized by worry, fear, or the feeling of restlessness. Anxiety can affect your overall well-being by hindering your ability to perform at your best in certain situations. ',
    symptoms: [
      'Restlessness',
      'Fast heartbeats',
      'Sweating, and problems in concentration.',
    ],
    treatment:
      'Therapy (Online counseling), medication, and lifestyle changes.',
    price: '99.99',
    id: 'z3AHsLgBbZ',
  },
  {
    title: 'Depression',
    description:
      'Depression is a complex and progressive mood disorder that involves feelings of sadness and a loss of interest or pleasure. Effective treatment for depression is the road to a healthier and more fulfilling life.',
    symptoms: [
      'Sadness',
      'Fatigue',
      'Fluctuations in sleep patterns, and appetite.',
    ],
    treatment: 'Therapy, antidepressant medications, care, and support.',
    price: '99.99',
    id: 'zuaEXy9q9S',
  },
  // {
  //   title: 'Insomnia',
  //   description:
  //     'Insomnia is a sleep disorder distinguished by difficulty in falling or staying asleep. This can result from a range of physical and psychological factors and can affect your day-to-day performance ',
  //   symptoms: ['Trouble sleeping', 'Fatigue', 'Irritability.'],
  //   treatment:
  //     'Practicing sleep hygiene habits engaging in behavioral therapy for insomnia (CBT I) and sometimes using medication.',
  //   price: '99.99',
  //   id: 'JLek8NEovn',
  // },
  {
    title: 'ADHD',
    description:
      'Attention Deficit/Hyperactivity Disorder (ADHD) is a condition that affects attention span and impulse control. This can make it hard for you to succeed in certain aspects of life by hindering your learning abilities.',
    symptoms: ['Inattention', 'Hyperactivity', 'Impulsivity.'],
    treatment:
      'Behavioral therapy techniques along with medication options and adjustments, in routines as needed.',
    price: '99.99',
    id: '4k75yxSlu4',
  },
  // {
  //   title: 'Social Anxiety',
  //   description:
  //     'Social Anxiety is an extreme and irrational fear of social situations and being judged by others. It can cause avoidance that interferes with your social life and relations.',
  //   symptoms: [
  //     'Excessive self-consciousness',
  //     'Fear of humiliation',
  //     'Avoidance of social situations.',
  //   ],
  //   treatment:
  //     'Cognitive-behavioral therapy (CBT), exposure therapy, and medications in some cases.',
  //   price: '99.99',
  //   id: 'ge0oXbjgco',
  // },
];
export { prescriptionData };
